import { CardTypes, PortfolioCard } from './types';
import { Reducer } from 'redux';

const initialState: PortfolioCard = {
 id: 0,
 profileId: '',
 userId: 0,
 templateId: 0,
 templateSubId: 0,
 cardImage: '',
 dynamicUrl: null,
 qrcode: '',
 qrcodeImage: '',
 createdDate: null,
 bussinesName: '',
 email: '',
 number: '',
 lastName: '',
 isPublished: '',
 backCardImage: null,
 isDefault: '',
 companyName: '',
 postDestination: null,
 isExistingCard: '',
 video: null,
 isLibrary: '',
 isDeleted: '',
 tempCard: 0,
 details: '',
 videoType: '',
 isCustom: '',
 adminTemplate: null,
 isEnterpriseCard: '',
 enterpriseId: null,
 enterpriseUsersId: null,
 enterpriseTemplateId: null,
 cardOrigin: null,
 jobTitle: '',
 license: '',
 fax: '',
 tollFree: '',
 direct: '',
 mobile: '',
 website: ''
};

const CardReducer: Reducer<PortfolioCard> = (state = initialState, action: any) => {
 switch (action.type) {
  case CardTypes.SET_CARD_DATA: {
   return { ...state, ...action.data };
  }
  default:
   return state;
 }
};

export default CardReducer;
